import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { FloatingArrow } from '@floating-ui/react';

/** Popover arrow that is optional for popovers */
const Arrow = forwardRef(({ fill = 'var(--color-bg)', translate = { x: 0, y: 0 }, ...props }, ref) => (jsx(FloatingArrow, { ref: ref, tipRadius: 1, fill: fill, strokeWidth: 0.5, style: { transform: `translateX(${translate.x}px)  translateY(${translate.y}px)` }, ...props })));
Arrow.displayName = 'PopoverPrimitive.Arrow';

export { Arrow };
//# sourceMappingURL=popover-primitive.arrow.js.map
